import React, { useEffect, useState } from 'react';
import styles from './excellentCase.module.scss';
import { withRouter } from 'react-router-dom';
import { ListView, PullToRefresh } from 'antd-mobile';
import  { ApiCore } from '../../api/index';
import login_bg from '../../static/images/login_bg.png';
import icon_green_arrow_down from '../../static/images_medicalLive/icon_green_arrow_down.png';
import icon_green_search from '../../static/images_medicalLive/icon_green_search.png';
import icon_search_clear from '../../static/images_medicalLive/search_clear.png';
import init_no_record from '../../static/images_medicalLive/init_no_record.png';
import search_no_record from '../../static/images_medicalLive/search_no_record.png';

import utils from '../../utils/utils';

const api = new ApiCore();

let delayExcute:any = null;

function ExcellentCase(props: any) {

    const [list, setList] = useState([]);
    const [initState, setInitState] = useState(true); // 首次显示暂无记录，搜索和分类时显示暂无查询记录
    const [listReady, setListReady] = useState(false);
    const [loading, setLoading] = useState(false);
    const [typeList, setTypeList] = useState([]);
    const [typeSelectedItem, setTypeItemSelected] = useState<any>(null);
    const [activeTypeIndex, setActiveTypeIndex] = useState(0);
    const [showTypeList, setShowTypeList] = useState(false);
    const [searchTitle, setSearchTitle] = useState<any>(null);
    const [projectCode, setProjectCode ] = useState<any>(null);
    const [isPullToRefresh, setIsPullToRefresh] = useState<boolean>(false); // 下拉刷新状态
    const [isMore, setIsMore] = useState<boolean>(true); // 是否还有更多数据
    const [curPage, setCurPage] = useState<number>(1); // 当前加载的页数
    const [curPageSize, setCurPageSize] = useState<number>(10); // 分页条数
    const [total, setTotal] = useState<number>(10); // 总条数

    useEffect(() => {
        initProject();
        return () => {
        }
    }, []);

    useEffect(() => {
        if (projectCode !== null) {
            initPageData();
            initTypeList();
        }
    }, [projectCode]);

    useEffect(() => {
        if (typeSelectedItem !== null) {
            initPageData();
        }
    }, [typeSelectedItem]);

    useEffect(() => {
        clearTimeout(delayExcute);
        if (searchTitle !== null) {
            delayExcute = setTimeout(() => {
                initPageData();
            }, 300);
        }
    }, [searchTitle]);

    const initProject = () => {
        let YMTCodes = sessionStorage.getItem('YMTCodes');
        if (YMTCodes) {
            let activeItem = {};
            try {
                activeItem = JSON.parse(YMTCodes);
            } catch (error) {
                activeItem = {};
            }
            // @ts-ignore
            let _projectCode = activeItem.projectCodes || '';
            if (_projectCode && _projectCode.indexOf(',') >= 0) {
                let __projectCode = _projectCode.split(',');
                setProjectCode(__projectCode);
            } else {
                setProjectCode([_projectCode]);
            }
        } else {
            const urlParams = utils.getUrlParams() || {};
            let _projectCode = urlParams.projectCodes || '';
            if (_projectCode && _projectCode.indexOf(',') >= 0) {
                let __projectCode = _projectCode.split(',');
                setProjectCode(__projectCode);
            } else {
                setProjectCode([_projectCode]);
            }
        }
    }

    // 获取列表数据
    const initPageData = () => {
        setListReady(false);
        setIsMore(true);
        setLoading(true);
        setCurPage(1);
        api.getSolicitationPage({
            projectCodes: projectCode,
            title: searchTitle ? searchTitle : '',
            label: typeSelectedItem ? typeSelectedItem.code : '',
            page: 1,
            pageSize: 10
        }).then((res: any) => {
            setLoading(false);
            if (res.code == 0) {
                setList((res.data && res.data.rows) || []);
                setTotal(res.data.total);
            }
            setListReady(true);
        });
    }

    //获取优秀案例类型标签列表
    const initTypeList = () => {
        api.getLabelList({
            projectCodes: projectCode,
            tenantCodes: []
        }).then((res: any) => {
            if (res.code == 0) {
                // @ts-ignore
                setTypeList([{name: '所有分类', code: ''}].concat((res.data || [])));
            }
        });
    }

    // 搜索标题变化
    const titleInput = (event: any) => {
        setSearchTitle(event.target.value);
        setInitState(false);
    }

    // 清除输入内容
    const clearInput = () => {
        setSearchTitle('');
    }

    // 展示、隐藏分类
    const toShowTypeList = () => {
        setShowTypeList(!showTypeList);
    }

    // 项目分类选择
    const typeItemClick = (item: any, index: number) => {
        setTypeItemSelected(item);
        setActiveTypeIndex(index);
        setInitState(false);
        setTimeout(() => {
            setShowTypeList(false);
        }, 200);
    }

    // 去详情页
    const toDetail = (item: any) => {
        props.history.push(`/medicalLiveDetail/${item.id}`);
    }

    // 下拉加载
    const onPullToRefresh = () => {
        setIsPullToRefresh(true);
        setIsMore(true);
        // 重置状态
        setListReady(false);
        setLoading(true);
        setCurPage(1);
        api.getSolicitationPage({
            projectCodes: projectCode,
            title: searchTitle ? searchTitle : '',
            label: typeSelectedItem ? typeSelectedItem.code : '',
            page: 1,
            pageSize: 10
        }).then((res: any) => {
            setLoading(false);
            if (res.code == 0) {
                setList((res.data && res.data.rows) || []);
                setTotal(res.data.total);
            }
            setListReady(true);
            setIsPullToRefresh(false);
        });
    }

    // 触底上拉刷新
    const onEndListAdded = () => {
        setListReady(false);
        setLoading(true);
        let nowPage = curPage;
        // 超出分页总数据后不再加载
        if (nowPage * curPageSize > total) {
            setIsMore(false);
            setLoading(false);
            return;
        }
        nowPage++;
        setCurPage(nowPage);
        api.getSolicitationPage({
            projectCodes: projectCode,
            title: searchTitle ? searchTitle : '',
            label: typeSelectedItem ? typeSelectedItem.code : '',
            page: nowPage,
            pageSize: 10
        }).then((res: any) => {
            setTimeout(() => {
                setLoading(false);
                if (res.code == 0) {
                    setList(list.concat(res.data && res.data.rows) || []);
                    setTotal(res.data.total);
                }
                setListReady(true);
                setIsPullToRefresh(false);
            }, 375);
        });
    }

    // 上拉触底
    const onEndReached = () => {
        if (isMore) {
            //加载数据
            onEndListAdded()
        }
    }

    const dataView = new ListView.DataSource({
        rowHasChanged: (row1: any, row2: any) => row1 !== row2,
    });

    const dataSource = dataView.cloneWithRows(list);

    const row = (val: any, index: any) => (
        <div className={styles.list_item} key={index} onClick={() => { toDetail(val) }}>
            <div className={styles.item_left_content}>
                <img className={styles.item_left_img} src={val.videoImg || login_bg} alt='' />
            </div>
            <div className={styles.item_right_content} >
                <div className={styles.item_right_title}>{val.title}</div>
                <div className={styles.item_right_middle}>
                    {val.introduction}
                </div>
                <div className={styles.item_right_bottom}>
                    <div className={styles.author}>{val.author} · {val.createTime ? val.createTime.slice(0, 10) : ''}</div>
                    <div className={styles.createTime}>共{val.viewNum}次浏览</div>
                </div>
            </div>
        </div>
    );

    return (
        <div className={`${styles.excellentCase_content}`}>
            <div className={styles.search_head}>
                <div className={styles.search}>
                    <img className={styles.search_img} src={icon_green_search} alt="" />
                    <input type="text" placeholder="请输入案例标题" value={searchTitle} onChange={(event) => { titleInput(event) }} />
                    {
                        searchTitle &&
                        <img className={`${styles.search_img_clear}`} src={icon_search_clear} alt="" onClick={ () => { clearInput() }} />
                    }
                </div>
                <div className={styles.type}>
                    <span onClick={() => { toShowTypeList() }}>分类</span>
                    <img src={icon_green_arrow_down} alt=""
                         className={`${showTypeList ? styles.type_img_rotate : ''}`}
                         onClick={() => { toShowTypeList() }} />
                    {
                        showTypeList && 
                        <div className={styles.project_list}>
                            {
                                typeList && (typeList || []).map((val: any, index) => (
                                    <div key={index}  className={`${index === activeTypeIndex ? styles.selected : ''}`} onClick={() => { typeItemClick(val, index) }}>{val.name}</div>
                                ))
                            }
                        </div>
                    }
                </div>

            </div>
            <div className={styles.list}>
                {
                    (list && list.length > 0) && 
                    <ListView
                        style={{ height: 'calc(100vh - 3.04rem)' }}
                        className={styles.listview}
                        dataSource={dataSource}
                        renderRow={row}
                        initialListSize={2000}
                        onEndReached={onEndReached}
                        onEndReachedThreshold={6}
                        scrollRenderAheadDistance={500}
                        scrollEventThrottle={200}
                        useBodyScroll={false}
                        pullToRefresh={
                            <PullToRefresh
                                damping={60}
                                distanceToRefresh={25}
                                indicator={{}}
                                direction="down"
                                refreshing={isPullToRefresh}
                                getScrollContainer={() => undefined}
                                onRefresh={() => {
                                    onPullToRefresh()
                                }}
                            >
                            </PullToRefresh>
                        }
                        renderFooter={() => (
                        <div style={{ padding: 0, textAlign: 'center' }}>
                            {loading ? '正在加载...' : '没有更多'}
                        </div>)}
                    />
                }
                { 
                    (listReady && (list && list.length == 0)) &&
                    <div className={styles.no_record_tip}>
                        <img src={initState ? init_no_record : search_no_record} alt="" />
                    </div>
                    
                }
            </div>
        </div>
    )

}

export default withRouter(ExcellentCase);